import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { Popups } from "ui/types/popups";

export const NotificationPopup = () => {
    const handleDiscardBtnClick = () => {
        GameUI.closePopup(Popups.NOTIFICATION_POPUP);
    }

    const handleShowNotificationPrompt = () => {
        (window as any)?.showNotificationPrompt();
        GameUI.closePopup(Popups.NOTIFICATION_POPUP, true);
    }
    
    return (
        <div id="push_notifications" role="tooltip" className="push_notifications modals_area active">
            <div className="wrapper">
                <div className="text_content">
                    <span className="modals_area-title">{translate("push_notifications_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/notification_popup/push_notifications.webp" />
                    <p className="modals_area-text">{translate("push_notifications_text")}</p>
                    <div className="feedback_btn-wrap">
                        <button type="button" className="discard_btn close" onClick={handleDiscardBtnClick}>{translate("discard_btn_text")}</button>
                        <button type="button" className="modals_area-btn" onClick={handleShowNotificationPrompt}>{translate("push_notifications_btn")}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}